import { Close } from '@mui/icons-material'
import { useAppServices } from 'hook/services'
import MDModal from 'components/MDModal'
import React, { useState } from 'react'

const DeleteNotification = ({ open, onClose, agency, Update, editNotification }) => {
    const Service = useAppServices();
    const [loading, setLoading] = useState(false)

    const deleteNotification = async () => {
        setLoading(true);
        const notifications = agency.notifications.filter(n => n.id !== editNotification.id);
        const payload = {
            notifications: notifications,
            _id: agency._id
        }
        const { response } = await Service.agency.update({ payload });
        if (response?.success) {
            Update({ notifications });
            onClose()
        } else {
            alert("Failed to update Notifications")
        }
        setLoading(false)
    }
    return (
        <MDModal open={open} onClose={onClose} width="650px" height="auto" overflow="visible">
            <button onClick={onClose} style={{ cursor: "pointer", position: 'fixed', top: '10px', right: "10px", background: "transparent", border: "none", fontSize: "18px" }}><Close /></button>
            <div>
                <p style={{ fontSize: "18px", fontWeight: "600", fontFamily: "Inter" }}>Delete Notification</p>
                <p style={{ fontSize: "14px", fontFamily: "Inter", marginTop: "8px" }}>Are you sure you want to delete this notification? This action cannot be undone.</p>
                <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
                    <button onClick={onClose} style={{ cursor: "pointer", background: "transparent", color: "#000", padding: "10px 20px", borderRadius: "3px", border: "1px solid black", width: "100%", fontSize: "14px", fontFamily: "Inter", fontWeight: "600" }}>Cancel</button>
                    <button onClick={deleteNotification} disabled={loading} style={{ cursor: "pointer", background: "rgba(234, 26, 26, 1)", color: "white", padding: "10px 20px", borderRadius: "3px", border: "none", width: "100%", fontSize: "14px", fontFamily: "Inter", fontWeight: "600" }}>{loading ? "Deleting..." : 'Delete'}</button>
                </div>
            </div>
        </MDModal>
    )
}

export default DeleteNotification